import React from "react";
import { Card } from "..";
import styles from "./styles.module.scss";
import {
  ActiveStudioIcon,
  ConnectedComputersIcon,
  DisconnectedComputersIcon,
  PaidStrikersIcon,
  TotalFreeStrikersIcon,
} from "icons";
import { UseApiCallV2 } from "hooks";

const list = [
  {
    id: 1,
    label: "Total Active Studios",
    value: 260,
    Icon: ActiveStudioIcon,
    info: "The number of computers currently online and actively in use.",
  },
  {
    id: 2,
    label: "Connected Computers",
    value: 260,
    Icon: ConnectedComputersIcon,
    info: "The total number of computers connected to the network.",
  },
  {
    id: 3,
    label: "Disconnected Computers",
    value: 260,
    Icon: DisconnectedComputersIcon,
    info: "The number of computers that are currently offline or disconnected.",
  },
  {
    id: 4,
    label: "Total Paid Strikers",
    value: 260,
    Icon: PaidStrikersIcon,
    info: "The number of strikers currently being paid for their active work.",
  },
  {
    id: 5,
    label: "Total Free Strikers",
    value: 260,
    Icon: TotalFreeStrikersIcon,
    info: "The number of available strikers ready to take on new tasks.",
  },
];

export const ListOfCards = () => {
  return (
    <div className={styles.listContainer}>
      {list.map((item) => (
        <Card key={item.id} item={item} />
      ))}
    </div>
  );
};
